import Slide, { SlideProps } from '@mui/material/Slide'
import Snackbar from '@mui/material/Snackbar'
import { Box, IconButton, Typography } from '@mui/material'
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../store/appHooks'
import { handleSnackBar } from '../../slices/global'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import WarningIcon from '@mui/icons-material/Warning'
import { Close } from '@mui/icons-material'

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="down" />
}

const GlobalSnackBar = () => {
  const { globalReducer }: any = useAppSelector((state) => state)
  const { snackbarConfig } = globalReducer
  const dispatch = useAppDispatch()

  const handleClose = () => {
    dispatch(
      handleSnackBar({
        open: false,
        message: '',
        severity: 'success',
      }),
    )
  }

  return (
    <Snackbar
      open={snackbarConfig.open}
      TransitionComponent={SlideTransition}
      onClose={handleClose}
      autoHideDuration={4000}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Box
        style={{
          background: '#FFF',
          boxShadow: '0px 4px 25px 0px #00000012',
          padding: '1.3rem',
          borderRadius: '0.2rem',
          borderBottom: `2px solid ${
            snackbarConfig.severity === 'success'
              ? '#2e7d32'
              : snackbarConfig.severity === 'error'
              ? '#d32f2f'
              : snackbarConfig.severity === 'warning'
              ? '#ed6c02'
              : '#0288d1'
          }`,
          display: 'flex',
          gap: '0.5rem',
        }}
      >
        <Box display="flex" gap={1.5} alignItems="center">
          {snackbarConfig.severity === 'success' && (
            <CheckCircleIcon color="success" />
          )}
          {snackbarConfig.severity === 'error' && <ErrorIcon color="error" />}
          {snackbarConfig.severity === 'warning' && (
            <WarningIcon color="warning" />
          )}
          <Typography>{snackbarConfig.message}</Typography>
        </Box>
        <Box>
          <IconButton size="small" onClick={handleClose}>
            <Close fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Snackbar>
  )
}

export default GlobalSnackBar
